var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"be-button-group"},[_vm._t("default",function(){return [_c('BeButton',[_vm._v("Some")]),_c('BeButton',[_vm._v("Example")]),_c('BeButton',[_vm._v("Buttons")])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }